const genId = (prefix = '', length = 6) => `${prefix}-${Math.random().toString(32).substr(2, 2 + length)}`


export default genId
